export default {_name:'text.iconBlock',module:'Field',view:'Element/Text/IconBlock',options:{direction:'column',md:12}}